import { render, staticRenderFns } from "./SizedArea.vue?vue&type=template&id=02310bb0&"
import script from "./SizedArea.vue?vue&type=script&lang=js&"
export * from "./SizedArea.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/jeffreymb/BibleLing/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('02310bb0')) {
      api.createRecord('02310bb0', component.options)
    } else {
      api.reload('02310bb0', component.options)
    }
    module.hot.accept("./SizedArea.vue?vue&type=template&id=02310bb0&", function () {
      api.rerender('02310bb0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/SizedArea.vue"
export default component.exports